import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
interface SlideCTAProps {
  onContinue: () => void;
}
export function SlideCTA({
  onContinue
}: SlideCTAProps) {
  const [stage, setStage] = useState(0);
  useEffect(() => {
    const timers = [300, 800, 1300, 1800, 2400].map((ms, idx) => setTimeout(() => setStage(idx + 1), ms));
    return () => timers.forEach(clearTimeout);
  }, []);
  const comparisons = [{
    left: 'Strategic brands',
    right: 'Legacy brands'
  }, {
    left: 'Global consistency',
    right: 'Local relevance'
  }, {
    left: 'Campaign scale',
    right: 'Campaign quality'
  }];
  return <div className="h-full w-full flex flex-col items-center justify-center px-8 py-12 md:px-20 relative bg-slate-50" data-id="element-494" data-mp="j2lq9ji37cd3">
      <div className="z-10 max-w-4xl w-full space-y-10 text-center" data-id="element-495" data-mp="o39e5wb0rd33">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="space-y-4" data-id="element-496" data-mp="t1knm5xejlks">
          <p className="text-[#6C2BD9] font-semibold tracking-widest uppercase text-sm" data-id="element-497" data-mp="2fwz218uqufwx">
            The Final Message
          </p>
          <h2 className="text-4xl md:text-6xl font-serif text-slate-900 leading-tight" data-id="element-498" data-mp="2axmesmzyn6tt">
            You should not have to choose
          </h2>
        </motion.div>

        <div className="space-y-4 max-w-3xl mx-auto" data-id="element-499" data-mp="20zpv36syj3k3">
          {comparisons.map((comp, idx) => <motion.div key={comp.left} initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: stage >= idx + 1 ? 1 : 0,
          y: stage >= idx + 1 ? 0 : 16
        }} className="bg-white border border-slate-200 rounded-2xl p-6 flex items-center justify-center gap-6 md:gap-12 shadow-sm" data-id="element-500" data-mp="2yngqv2cggrd0" data-mpi={idx}>
              <p className="text-xl md:text-2xl font-serif text-slate-800 flex-1 text-right" data-id="element-501" data-mp="2jxj0cfr1zpkn">
                {comp.left}
              </p>
              <div className="px-3 py-1 rounded-full bg-rose-50 border border-rose-200 text-rose-400 text-[11px] font-bold uppercase tracking-widest shrink-0" data-id="element-502" data-mp="3hg16hi358zyv">
                OR
              </div>
              <p className="text-xl md:text-2xl font-serif text-slate-800 flex-1 text-left" data-id="element-503" data-mp="1arsdns72gu0o">
                {comp.right}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: stage >= 4 ? 1 : 0,
        y: stage >= 4 ? 0 : 16
      }} className="bg-[#6C2BD9]/[0.08] border border-[#6C2BD9]/20 rounded-2xl p-8 md:p-10 max-w-4xl mx-auto mt-8" data-id="element-504" data-mp="10zmf1zmb7eci">
          <p className="text-2xl md:text-3xl font-serif text-slate-900 mb-4" data-id="element-505" data-mp="w1ul7023ti5o">
            LEO creates the strategic foundation.{' '}
            <span className="text-[#6C2BD9]" data-id="element-506" data-mp="i2v0u4lmjpfb">Snakker activates it.</span>
          </p>
          <p className="text-slate-600 text-base md:text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-507" data-mp="n0myzgcv47ry">
            For strategic brands, we make the content work harder. For mature
            and legacy brands, we take responsibility for keeping the campaign
            engine running.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: stage >= 4 ? 1 : 0
      }} className="pt-8 flex justify-center" data-id="element-508" data-mp="5ooif4fu9hdd">
          <button onClick={() => window.print()} className="flex items-center gap-2 px-6 py-3 rounded-full bg-slate-900 text-white hover:bg-slate-800 transition-colors font-semibold shadow-lg hover:shadow-xl" data-id="element-509" data-mp="fhnflapeig8l">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-510" data-mp="oj3jr0pmhm4d">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" data-id="element-511" data-mp="ye53fh14pvzk" />
            </svg>
            Download as PDF
          </button>
        </motion.div>
      </div>
    </div>;
}